"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { Body } from "@shared/ui/typography";

import s from "./coming-soon.module.scss";

export type ComingSoonProps = ComponentProps<"div"> & {
  className?: string;
  text: string;
};

export const ComingSoon = (props: ComingSoonProps) => {
  const { className, text } = props;

  return (
    <div className={clsx(s.root, className)}>
      <svg
        className={s.bg}
        viewBox="0 0 152 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0H21.5364H152L140.098 12.6L146.899 16.8L142.365 23.1L146.899 28H5.10072L13.6019 16.8H5.10072L11.7796 8.4L0 0Z"
          fill="#54220E"
          fillOpacity="0.1"
        />
      </svg>
      <Body className={s.text} size="uppercase-small" weight="semiBold">
        {text}
      </Body>
    </div>
  );
};

ComingSoon.displayName = "ComingSoon";
